import { Alert, Container } from "react-bootstrap";

const Search = () => {
    return (

        <Container className="mt-5 mb-5">

            <Alert variant="success">
                Search feature will appear here.
            </Alert>

        </Container>

    );
}
 
export default Search;